import './styles.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

export default class FloatingField extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    options: PropTypes.array,
    meta: PropTypes.object,
    onChangeAction: PropTypes.func,
    onBlur: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = { focus: false }
  }

  handleFocusClick = () => {
    const field = ReactDOM.findDOMNode(this.refs.field)
    field.focus()
  }

  handleFocus = () => {
    this.setState({ focus: true })
  }

  handleBlur = () => {
    this.setState({ focus: false })
    if (this.props.onBlur) {
      this.props.onBlur()
    }
  }

  updateValue = e => {
    const {
      onChangeAction,
      input: { onChange }
    } = this.props

    if (onChangeAction !== undefined) {
      onChangeAction(e.target.value)
    }

    onChange(e)
  }

  render () {
    const {
      input,
      placeholder,
      disabled,
      maxLength,
      meta: { touched, error }
    } = this.props
    const { value } = input
    const { focus } = this.state

    return (
      <span className={touched && error ? 'floating-field with-error' : 'floating-field'}>
        <label className={value || focus ? 'floating' : 'in-field'} onClick={this.handleFocusClick}>
          {placeholder}
        </label>
        <input
          ref='field'
          type='text'
          className='input-text'
          placeholder=''
          disabled={disabled}
          value={value}
          onChange={this.updateValue}
          maxLength={maxLength}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
        {touched && error && <div className='floating-error'>{error}</div>}
      </span>
    )
  }
}
